import { useEffect, useRef } from "react";

export const useVersionConflictSync = (updatedAt: string, callback: () => void) => {
	const callbackRef = useRef(callback);
	callbackRef.current = callback;
	const initialUpdateRef = useRef(updatedAt);
	useEffect(() => {
		if (updatedAt !== initialUpdateRef.current) {
			callbackRef.current();
		}
	}, [updatedAt]);
};
